import ATE from "../../../ActionTypeEnum";
import { summaryInitialState } from "../../../initial-state";
import ISummaryState from "../interfaces/ISummaryState";

export default function reduce(
        state: ISummaryState = summaryInitialState,
        action: {type: ATE, value?: any}
    ): ISummaryState {

    switch (action.type) {

        default:
            return state;

    }
}
